module.exports = __webpack_public_path__ + "img/2_196.fd3a2dd8.png";